<template>
  <div class="modal fade" id="infoSolicitation" role="dialog">
    <div class="modal-dialog modal-solicitation">
      <div class="modal-content">
        <div class="modal-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <g clip-path="url(#clip0_21_674)">
              <path d="M16.9575 14.2425L10.1475 7.43248C10.845 5.67748 10.485 3.60748 9.06753 2.18248C7.34253 0.457478 4.65753 0.299978 2.74503 1.69498L5.62503 4.58248L4.56003 5.63998L1.68753 2.76748C0.292532 4.67248 0.450032 7.36498 2.17503 9.08248C3.57003 10.4775 5.60253 10.845 7.34253 10.1925L14.175 17.025C14.4675 17.3175 14.94 17.3175 15.2325 17.025L16.9575 15.3C17.2575 15.015 17.2575 14.5425 16.9575 14.2425ZM14.7075 15.4425L7.61253 8.34748C7.15503 8.68498 6.64503 8.88748 6.11253 8.96248C5.09253 9.11248 4.02003 8.80498 3.24003 8.02498C2.52753 7.31998 2.19753 6.37498 2.25003 5.44498L4.56753 7.76248L7.74753 4.58248L5.43003 2.26498C6.36003 2.21248 7.29753 2.54248 8.01003 3.24748C8.82003 4.05748 9.12753 5.17498 8.94003 6.21748C8.85003 6.74998 8.62503 7.24498 8.28003 7.68748L15.3675 14.775L14.7075 15.4425Z" fill="#3A424E"/>
            </g>
            <defs>
              <clipPath id="clip0_21_674">
                <rect width="18" height="18" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <h2>Solicitar Ajuste/Abono</h2>
          <ion-icon @click="closeModal" name="close-outline"></ion-icon>
        </div>

        <div v-if="objValue" class="first-section">
          <h3>{{objValue.date | strDayFull}}, <span>{{objValue.date | dateDay}} de {{objValue.date | strMonthFull}}</span> de {{objValue.date | yearNumber}}</h3>
          <div class="box-buttons">
            <button :class="{btnAdjustment: typeSelected === 1}" @click="typeSelected = 1">Ajuste de ponto</button>
            <button :class="{btnAllowance: typeSelected === 2}" @click="typeSelected = 2">Abono</button>
            <button v-if="enableDsr" :class="{btnDrs: typeSelected === 3}" @click="typeSelected = 3">Justificativa DSR</button>
          </div>
        </div>

        <div class="second-section" v-if="typeSelected === 2">
          <label>
            <input type="checkbox" v-model="isAbonoAllDay">
            <span>Abono para o dia todo</span>
          </label>
          <label>
            <input type="checkbox" v-model="payMissingHours">
            <span>Abonar restante de horas faltantes do dia</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 15 14" fill="none">
              <path d="M7.5 1.53131C4.48453 1.53131 2.03125 3.98459 2.03125 7.00006C2.03125 10.0155 4.48453 12.4688 7.5 12.4688C10.5155 12.4688 12.9688 10.0155 12.9688 7.00006C12.9688 3.98459 10.5155 1.53131 7.5 1.53131ZM7.5 3.7735C7.64061 3.7735 7.77806 3.81519 7.89498 3.89331C8.01189 3.97143 8.10301 4.08247 8.15682 4.21237C8.21063 4.34228 8.22471 4.48522 8.19728 4.62313C8.16985 4.76104 8.10213 4.88772 8.00271 4.98714C7.90328 5.08657 7.77661 5.15428 7.6387 5.18171C7.50079 5.20914 7.35784 5.19507 7.22794 5.14126C7.09803 5.08745 6.987 4.99632 6.90888 4.87941C6.83076 4.7625 6.78906 4.62505 6.78906 4.48444C6.78906 4.29588 6.86396 4.11505 6.99729 3.98173C7.13062 3.8484 7.31145 3.7735 7.5 3.7735ZM9.25 9.95319H5.96875V9.07819H7.17188V6.67194H6.29688V5.79694H8.04688V9.07819H9.25V9.95319Z" fill="#7F8897"/>
            </svg>
            <p>Serão abonadas todas as horas faltantes que o funcionário teve nesse dia, quitando o saldo do dia.</p>
          </label>
        </div>

        <div class="third-section">
          <img src="../../../assets/img/img-drag.png">
          <p>Toque e segure um item da lista para reordena-los</p>
        </div>

        <div class="drag-content" v-if="!isAbonoAllDay && !payMissingHours && typeSelected !== 3">
          <div class="draggable-box">
            <div class="draggable-list">
              <div class="item" v-for="(item, index) in dataValues" :key="index" :style="{'border' : item.error ? '1px solid red' : ''}" draggable="true" @dragover.prevent @dragstart="dragInitial(index)" @drop="drop(index)">
                <div class="delete"><ion-icon @click="removeDate(index)" name="trash-bin-outline"></ion-icon></div>
                <p>Ponto - <span v-if="item.type === 1">Entrada</span><span v-else style="color: #FF445D">Saída</span></p>
                <div class="box-inputs">
                  <div class="input-date">
                    <span>Dia: </span>
                    <input v-model="item.date" v-mask="'##/##/####'" @change="validateDate(item)" type="text">
                  </div>
                  <div class="input-text">
                    <span>Hora: </span>
                    <input type="text" v-model="item.hour" v-mask="'##:##'" @change="validateHour(item)" maxlength="5" placeholder="00:00">
                  </div>
                </div>
                <ion-icon name="menu-outline"></ion-icon>
              </div>
              <span v-if="dateHourError" class="error-value">Preencha os dados corretamente!</span>
              <button @click="createDate(dataValues.length)" class="create">
                <ion-icon name="add-circle-outline"></ion-icon>
                <span>Adicionar período</span>
              </button>
            </div>
          </div>
        </div>

        <div class="content-motive">
          <label v-if="typeSelected === 1">
            <span>Motivo</span>
            <select v-model="motiveAdjustment">
              <option v-for="a in listAdj" v-bind:value="a">{{a.name}}</option>
            </select>
            <ion-icon name="chevron-down-outline"></ion-icon>
          </label>
          <label v-if="typeSelected === 2">
            <span>Motivo</span>
            <select v-model="motiveAllowance">
              <option v-for="a in listAdjAbono" v-bind:value="a">{{a.name}}</option>
            </select>
            <ion-icon name="chevron-down-outline"></ion-icon>
          </label>
          <label v-if="needException">
            <span>Motivo do ponto por exceção</span>
            <select v-model="motiveException">
              <option v-for="a in listException" v-bind:value="a">{{a.name}}</option>
            </select>
            <ion-icon name="chevron-down-outline"></ion-icon>
          </label>
          <label v-if="motiveAdjustment.name.toLowerCase() === 'outro' || motiveAllowance.name.toLowerCase() === 'outro'">
            <span>Informe o motivo</span>
            <input v-model="dataSend.reason" type="text" name="obs" required>
          </label>
          <span v-if="(motiveAdjustment.name.toLowerCase() === 'outro' || motiveAdjustment.name.toLowerCase() === 'outros') && !dataSend.reason && invalidMotive" class="required-field">Preencha o motivo.</span>
          <span v-if="!invalidMotive && $v.motiveAdjustment.$error" class="required-field">Selecione o motivo da solicitação.</span>
          <span v-if="invalidMotive && motiveAdjustment.name.toLowerCase() === 'selecione'" class="required-field">Selecione o motivo da solicitação.</span>
          <span v-if="validateException" class="required-field">Selecione o motivo da exceção.</span>
        </div>

        <div class="input-upload">
          <span class="name-file">{{fileName}}</span>
          <button @click="attachFile('#documentFile1')">
            <div v-if="loadingFile" class="animation">
              <ion-icon name="reload-circle-outline"></ion-icon>
            </div>
            <ion-icon v-else name="cloud-upload-outline"></ion-icon>
            <span>Adicionar anexo</span>
          </button>
          <input type="file" id="documentFile1" ref="myFiles" @change="previewFiles" style="display: none">
        </div>
        <button v-if="typeSelected === 1 || typeSelected === 3" @click="checkAdjustmentOrDsr(typeSelected)" class="btn-request">
          <div v-if="loadingSend" class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
          <span v-else>Enviar solicitação de ajuste</span>
        </button>
        <button v-if="typeSelected === 2" @click="checkAbono" class="btn-request">
          <div v-if="loadingSend" class="loading-btn">
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
          <span v-else>Enviar solicitação de abono</span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import moment from "moment";
import swal from "sweetalert";
import {REQUEST_SERVICE} from "../../../requestConfig";
import {
  ADJUSTMENT,
  CAN_MAKE_SOLICITATION,
  GET_COMPANY_ADJ,
  GET_EXCEPTION,
  POINT_DAY,
  UPLOAD_IMG
} from "../../../urlConfig";
import {UTIL_SERVICE} from "../../../utils";
import {minLength, required} from "vuelidate/lib/validators";
  export default {
    name: 'modalSolicitation',
    props: ['loadData'],
    data () {
      return {
        loadingFile: false,
        loadingSend: false,
        typeSelected: 1,
        enableDsr: false,
        listAdj: [],
        listAdjAbono: [],
        listPoint: [],
        ptBR: ptBR,
        uploadStage: "",
        files: [],
        fileName: "",
        dataValues: [],
        dataSend: {
          reason: "",
          imageUri: "",
          userPointAdjustmentStatus: "",
          userPointAdjustmentType: 0,
          userPointDayId: this.$route.params.idPoint,
          listDates: [],
          deviceId: "",
          deviceType: ""
        },
        historyListPoints:null,
        objValue: "",
        isAbonoAllDay: false,
        listHours: [{entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true}, { entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true}],
        listHoursAbonoHalfDay: [{entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true}],
        payMissingHours: false,
        listException: [],
        lastDateFormated: "",
        storageHomeCtrl: null,
        myOccurrenceCtrl: null,
        pointHistoryCtrl: null,
        needException: false,
        validateException: false,
        motiveException: "",
        motiveAdjustment: {
          name: 'Selecione',
          id: ''
        },
        motiveAllowance: {
          name: 'Selecione',
          id: ''
        },
        invalidMotive: false,
        dateHourError: false,
        valueDragging : null,
      }
    },
    methods: {
      drop(index) {
        const draggedItem = this.dataValues[this.valueDragging];
        this.dataValues.splice(this.valueDragging, 1);
        this.dataValues.splice(index, 0, draggedItem);
        this.orderList();
      },
      dragInitial(value) {
        this.valueDragging = value;
      },
      orderList() {
        this.dataValues.map((item, index) => {
          if (index % 2 === 0) {
            item.type = 1;
          } else {
            item.type = 2;
          }
        })
      },
      convertDataValues() {
        this.listHours.forEach((value) => {
          let entry = {
            date: value.entry ? value.entry : this.objValue.convertDate,
            hour: value.hourEntry,
            type: 1,
            error: false
          }
          this.dataValues.push(entry);

          let exit = {
            date: value.exit ? value.exit : this.objValue.convertDate,
            hour: value.hourExit,
            type: 2,
            error: false
          }
          this.dataValues.push(exit);
        })
      },
      sendRequest() {
        if (!this.loadingSend) {
          this.historyListPoints = UTIL_SERVICE.getStorage('historyListPoints');
          this.historyListPoints.showNew = true;
          this.historyListPoints.count = 1;

          if (this.historyListPoints.list.length >= 10)
            this.historyListPoints.list.splice(this.historyListPoints.list.length - 1, 1);

          this.loadingSend = true;

          this.dataSend.pointReference = this.objValue.pointReference;
          this.dataSend.deviceId = JSON.parse(window.localStorage.getItem('browserId'));
          this.dataSend.deviceType = "3";

          if(this.payMissingHours) {
            this.dataSend.fillHoursMissing = true;
            this.dataSend.listDates = [];
          }

          UTIL_SERVICE.console("DATA SEND:" , this.dataSend);
          REQUEST_SERVICE.post(ADJUSTMENT, this.dataSend).then((response) => {
            UTIL_SERVICE.console("RESULT ADJUSTMENT DOCUMENT: ", response);

            if (this.myOccurrenceCtrl)
              UTIL_SERVICE.saveStorage('myOccurrenceCtrl', this.myOccurrenceCtrl);

            if (this.pointHistoryCtrl)
              UTIL_SERVICE.saveStorage('pointHistoryCtrl', this.pointHistoryCtrl);

            this.historyListPoints.list.unshift({text: 'Ajuste solicitado para o dia: ', date: this.objValue.date, type: 2});
            UTIL_SERVICE.saveStorage('historyListPoints', this.historyListPoints);

            // Remove Storage from list solicitation
            UTIL_SERVICE.saveStorage('myRequestsCtrl', { dateAtt: null, dataControl: null, data: null });

            this.loadingSend = false;

            const homeCtrl = UTIL_SERVICE.getStorage('homeCtrl')
            homeCtrl.homeNeedReload = true;
            homeCtrl.advicesNeedReload = true;
            UTIL_SERVICE.saveStorage('homeCtrl', homeCtrl)

            swal("Aviso", response.data, "success").then(() => {
              this.closeModal();
              this.$router.push({path: '/detalhe-do-ponto/' + this.$route.params.idPoint + '/' + this.$route.params.type});
              location.reload();
            });

          }).catch(reason => {
            try {
              UTIL_SERVICE.historyLog(false, window.location.pathname, 'sendRequest', this.dataSend, true, reason.response.data);
            } catch (e) {}

            this.loadingSend = false;
            // Show errors.
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
        }
      },
      checkAdjustmentOrDsr(value) {
        value === 1 ? this.checkAdjustment() : this.checkAdjustmentDsr();
      },
      checkAdjustmentDsr() {
        this.dateHourError = false;
        this.invalidMotive = false;
        this.dataSend.userPointAdjustmentType = 6;
        this.$v.dataSend.$touch();

        if (this.motiveAllowance.name.toLowerCase() === 'selecione') {
          this.invalidMotive = true;
          return;
        }
        if (this.motiveAllowance.name.toLowerCase() === 'outro' && !this.dataSend.reason) {
          this.invalidMotive = true;
          return;
        }

        if (this.motiveAllowance.name.toLowerCase() !== 'outro') {
          this.dataSend.reason = this.motiveAllowance.name;
        }

        this.dataSend.userPointAdjustmentStatus = this.motiveAllowance.id;
        if (!this.invalidMotive) {
          this.sendRequest();
        }
      },
      checkAdjustment() {
        this.dateHourError = false;
        let isValidForm = true;
        this.invalidMotive = false;
        this.dataSend.listDates = [];
        this.dataSend.userPointAdjustmentType = 1;

        this.$v.dataSend.$touch();
        this.$v.listHours.$touch();

        // Cancel form if you have an error.
        if (this.$v.dataSend.$error) return;

        // Check whether the select contains the value 4 and is empty.
        if (this.motiveAdjustment.name.toLowerCase() === 'selecione') {
          this.invalidMotive = true;
          return;
        }
        if (this.motiveAdjustment.name.toLowerCase() === 'outro' && !this.dataSend.reason) {
          this.invalidMotive = true;
          return;
        }

        if (this.motiveAdjustment.name.toLowerCase() !== 'outro') {
          this.dataSend.reason = this.motiveAdjustment.name;
        }

        if(this.needException) {
          if(this.motiveException) {
            this.dataSend.sporadicCategoryId = this.motiveException.id
            this.validateException = false
          } else {
            return this.validateException = true
          }
        }

        this.dataSend.userPointAdjustmentStatus = this.motiveAdjustment.id;

        if (this.dataValues.length) {
          this.dataValues.map((value, index) => {
            let isValidHour = this.checkHoursIsValid(value.hour);

            // Check all dates and hours is valid.

            if (UTIL_SERVICE.checkDateStringIsInvalid(value.date) || !isValidHour) {
              isValidForm = false;
              value.error = true
              this.dateHourError = true;
            }

            // Case is valid add to list.
            if (isValidForm) {
              this.dataSend.listDates.push({
                date: moment(UTIL_SERVICE.convertStringToDateEua(value.date)).format('YYYY-MM-DD') + "T" + value.hour + ":00",
                userPointType: value.type === 1 ? 1 : 2
              });
            }

            if (this.dataValues.length === index + 1) {
              if (isValidForm) {
                this.sendRequest();
              }
            }
          });
        } else {
          this.sendRequest();
        }
      },
      checkAbono() {
        this.dateHourError = false;
        this.invalidMotive = false;
        this.dataSend.userPointAdjustmentType = 2;
        this.$v.dataSend.$touch();

        // Check sure it's for the whole day.
        if (this.isAbonoAllDay === "false" && !this.payMissingHours) {
          // Touch input from date
          this.$v.listHoursAbonoHalfDay.$touch();
          // Cancel form if you have an error
          if (this.$v.listHoursAbonoHalfDay.$error) return;
        }

        // Cancel form if you have an error.
        if (this.$v.dataSend.$error) return;

        // Check whether the select contains the value 4 and is empty.
        if (this.motiveAllowance.name.toLowerCase() === 'selecione') {
          this.invalidMotive = true;
          return;
        }
        if (this.motiveAllowance.name.toLowerCase() === 'outro' && !this.dataSend.reason) {
          this.invalidMotive = true;
          return;
        }

        if (this.motiveAllowance.name.toLowerCase() !== 'outro') {
          this.dataSend.reason = this.motiveAllowance.name;
        }

        if(this.needException) {
          if(this.motiveException) {
            this.dataSend.sporadicCategoryId = this.motiveException.id
            this.validateException = false
          } else {
            return this.validateException = true
          }
        }

        this.dataSend.isAbonoAllDay = this.isAbonoAllDay;

        this.dataSend.userPointAdjustmentStatus = this.motiveAllowance.id;
        if (this.isAbonoAllDay === true || this.isAbonoAllDay === false && this.payMissingHours) {
          if (!this.objValue.userPointJson || this.isAbonoAllDay === false) {
            this.sendRequest();
          }
          else {
            swal("Aviso", "\nNão é possivel realizar este abono pelo motivo:\n Existe ponto registrado para esse dia. Ao invés disso, solicite um ajuste.", "error");
          }
        } else {
          this.dataSend.listDates = [];
          let isValidForm = true;

          if (this.dataValues.length) {
            this.dataValues.map((value, index) => {
              let isValidHour = this.checkHoursIsValid(value.hour);

              // Check all dates and hours is valid.
              if (UTIL_SERVICE.checkDateStringIsInvalid(value.date) || !isValidHour) {
                isValidForm = false;
                value.error = true
                this.dateHourError = true;
              }

              if (isValidForm) {
                this.dataSend.listDates.push({
                  date: moment(UTIL_SERVICE.convertStringToDateEua(value.date)).format('YYYY-MM-DD') + "T" + value.hour + ":00",
                  userPointType: value.type === 1 ? 1 : 2
                });
              }

              if (this.dataValues.length === index + 1) {
                if (isValidForm) {
                  this.sendRequest();
                }
              }
            });
          } else {
            this.dateHourError = true;
          }
        }
      },
      attachFile(id) {
        $(id).click();
      },
      previewFiles() {
        this.loadingFile = true;
        this.files = this.$refs.myFiles.files;
        if (this.files.length) {
          if (this.files[0].size <= 2097152) {
            this.uploadDocument(this.files[0]);
          } else {
            swal("Aviso", "Não foi possivel realizar o envio da imagem.\n\n Motivo: arquivo muito grande por favor enviar um arquivo menor que 2MB.", "warning");
            this.loadingFile = false;
          }
        }
      },
      uploadDocument(file) {
        REQUEST_SERVICE.fileUpload(UPLOAD_IMG, file).then((response) => {
          UTIL_SERVICE.console("RESULT UPLOAD DOCUMENT: ", response);

          this.dataSend.imageUri = response.data;
          this.loadingFile = false;
          this.fileName = file.name;

        }).catch(reason => {
          this.loadingFile = false;
        });
      },
      createDate(value) {
        this.dateHourError = false;
        let obj = {}
        if (value % 2 === 0) {
          obj.date = this.objValue.convertDate;
          obj.hour = '';
          obj.type = 1;
          obj.error = false;
        } else {
          obj.date = this.objValue.convertDate;
          obj.hour = '';
          obj.type = 2;
          obj.error = false;
        }
        this.dataValues.push(obj);
      },
      removeDate(index) {
        this.dataValues.splice(index, 1);
        this.orderList();
      },
      closeModal(){
        $('#infoSolicitation').modal('toggle');
      },
      convertDate(value) {
        return new Date(value);
      },
      customFormatter(date) {
        return moment(date).format('DD/MM/YYYY');
      },
      checkHoursIsValid(hour) {
        return /^([0-1]?[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?$/.test(hour);
      },
      validateHour(value) {
        if (this.checkHoursIsValid(value.hour)) {
          value.error = false;
        } else {
          value.error = true;
        }
      },
      validateDate(value) {
        if (UTIL_SERVICE.checkDateStringIsInvalid(value.date)) {
          value.error = true;
        } else {
          value.error = false;
        }
      },
      makeSolicitation() {
        this.loading = true;
        REQUEST_SERVICE.get(CAN_MAKE_SOLICITATION + "?id=" + this.$route.params.idPoint).then((response) => {
          UTIL_SERVICE.console("RESULT CAN_MAKE_SOLICITATION:", response.data);

          if (response.data.canRequest) {
            this.getDetail();
          } else {
            this.closeModal();
            swal({
              text: response.data.text,
              title: 'Atenção',
              closeOnClickOutside: false,
              button: {
                text: "Confirmar",
                closeModal: false,
              },
            }).then(pass => {
              if (!pass) throw null;

              swal.stopLoading();
              swal.close();
              location.reload();
            }).catch(err => {
              swal.stopLoading();
              swal.close();
              location.reload();
            });
          }
        }).catch(reason => {
          this.loading = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      getDetail() {
        this.loading = true;

        REQUEST_SERVICE.get(POINT_DAY + this.$route.params.idPoint).then((response) => {
          UTIL_SERVICE.console("RESULT POINT_DAY:", response.data);
          response.data.strDay = moment(response.data.date).format("dddd");
          response.data.convertDate = moment(response.data.date).format("DD/MM/YYYY");

          this.listHoursAbonoHalfDay[0].entry = moment(response.data.date).format('DD/MM/YYYY');
          this.listHoursAbonoHalfDay[0].exit = moment(response.data.date).format('DD/MM/YYYY');

          // Convert Json to points
          if (response.data.userPointJson) {
            response.data.userPointJsonConvert = JSON.parse(response.data.userPointJson);
            response.data.userPointJsonConvert = response.data.userPointJsonConvert.slice().reverse();
          }

          // Add list from points case exist
          if (typeof response.data.userPointJsonConvert !== "undefined") {
            if (response.data.userPointJsonConvert.length >= 5)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            if (response.data.userPointJsonConvert.length >= 7)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            if (response.data.userPointJsonConvert.length >= 9)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            if (response.data.userPointJsonConvert.length >= 11)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            if (response.data.userPointJsonConvert.length >= 13)
              this.listHours.push({entry: '', hourEntry: '', exit: '', hourExit: '', isValidEntry: true, isValidExit: true, isDateEntry: true, isDateExit: true});

            response.data.userPointJsonConvert.map((value, index) => {
              if (value.Date)
                this.lastDateFormated = moment(value.Date).format('DD/MM/YYYY');

              if (value.date)
                this.lastDateFormated = moment(value.date).format('DD/MM/YYYY');

              if (value.date) {
                if (!this.listHours[0].hourEntry) {
                  this.listHours[0].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHoursAbonoHalfDay[0].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[0].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[0].hourExit) {
                  this.listHours[0].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHoursAbonoHalfDay[0].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[0].hourExit = value.hour.substring(0, 5);
                } else if (!this.listHours[1].hourEntry) {
                  this.listHours[1].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[1].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[1].hourExit) {
                  this.listHours[1].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[1].hourExit = value.hour.substring(0, 5);
                } else if (!this.listHours[2].hourEntry) {
                  this.listHours[2].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[2].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[2].hourExit) {
                  this.listHours[2].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[2].hourExit = value.hour.substring(0, 5);
                } else if (!this.listHours[3].hourEntry) {
                  this.listHours[3].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[3].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[3].hourExit) {
                  this.listHours[3].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[3].hourExit = value.hour.substring(0, 5);
                } else if (!this.listHours[4].hourEntry) {
                  this.listHours[4].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[4].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[4].hourExit) {
                  this.listHours[4].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[4].hourExit = value.hour.substring(0, 5);
                }  else if (!this.listHours[5].hourEntry) {
                  this.listHours[5].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[5].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[5].hourExit) {
                  this.listHours[5].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[5].hourExit = value.hour.substring(0, 5);
                }  else if (!this.listHours[6].hourEntry) {
                  this.listHours[6].entry = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[6].hourEntry = value.hour.substring(0, 5);
                } else if (!this.listHours[6].hourExit) {
                  this.listHours[6].exit = moment(value.date).format('DD/MM/YYYY');
                  this.listHours[6].hourExit = value.hour.substring(0, 5);
                }
              } else {
                if (!this.listHours[0].hourEntry) {
                  this.listHours[0].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHoursAbonoHalfDay[0].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[0].hourEntry = value.Hour.substring(0, 5);

                  if (!this.listHours[0].hourExit) {
                    this.listHoursAbonoHalfDay[0].exit = moment(value.Date).format('DD/MM/YYYY');
                  }
                } else if (!this.listHours[0].hourExit) {
                  this.listHours[0].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHoursAbonoHalfDay[0].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[0].hourExit = value.Hour.substring(0, 5);
                } else if (!this.listHours[1].hourEntry) {
                  this.listHours[1].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[1].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[1].hourExit) {
                  this.listHours[1].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[1].hourExit = value.Hour.substring(0, 5);
                } else if (!this.listHours[2].hourEntry) {
                  this.listHours[2].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[2].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[2].hourExit) {
                  this.listHours[2].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[2].hourExit = value.Hour.substring(0, 5);
                } else if (!this.listHours[3].hourEntry) {
                  this.listHours[3].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[3].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[3].hourExit) {
                  this.listHours[3].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[3].hourExit = value.Hour.substring(0, 5);
                } else if (!this.listHours[4].hourEntry) {
                  this.listHours[4].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[4].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[4].hourExit) {
                  this.listHours[4].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[4].hourExit = value.Hour.substring(0, 5);
                }  else if (!this.listHours[5].hourEntry) {
                  this.listHours[5].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[5].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[5].hourExit) {
                  this.listHours[5].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[5].hourExit = value.Hour.substring(0, 5);
                }  else if (!this.listHours[6].hourEntry) {
                  this.listHours[6].entry = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[6].hourEntry = value.Hour.substring(0, 5);
                } else if (!this.listHours[6].hourExit) {
                  this.listHours[6].exit = moment(value.Date).format('DD/MM/YYYY');
                  this.listHours[6].hourExit = value.Hour.substring(0, 5);
                }
              }
            });
          }

          setTimeout(() => {
            if (!this.listHours[0].entry)
              this.listHours[0].entry = this.objValue.convertDate;

            if (!this.listHours[0].exit)
              this.listHours[0].exit = this.listHours[0].entry;

            if (!this.listHours[1].entry)
              this.listHours[1].entry =  this.listHours[0].exit;

            if (!this.listHours[1].exit)
              this.listHours[1].exit = this.listHours[1].entry;
          }, 300);

          this.objValue = response.data;

          // Saves values to variables
          this.storageHomeCtrl = UTIL_SERVICE.getStorage('homeCtrl');
          this.myOccurrenceCtrl = UTIL_SERVICE.getStorage('myOccurrenceCtrl');
          this.pointHistoryCtrl = UTIL_SERVICE.getStorage('pointHistoryCtrl');

          // Change value 'userPointAdjustmentStatus' to pending adjustment
          if (this.storageHomeCtrl) {
            if (this.storageHomeCtrl.listPoint.length) {
              this.storageHomeCtrl.listPoint.map((value, index) => {
                if (value.id === this.$route.params.idPoint) {
                  value.userPointAdjustmentStatus = 1;
                }
              });
            }
          }

          if (this.pointHistoryCtrl) {
            if (this.pointHistoryCtrl.listHistory.length) {
              this.pointHistoryCtrl.listHistory.map((value, index) => {
                if (value.id === this.$route.params.idPoint) {
                  value.userPointAdjustmentStatus = 1;
                }
              });
            }
          }
          this.convertDataValues();
          this.loading = false;
        }).catch(reason => {
          try {
            UTIL_SERVICE.historyLog(false, window.location.pathname, 'getDetail', {id: this.$route.params.idPoint}, true, reason.response.data);
          } catch (e) {}
          this.loading = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      getListAdjustment() {
        REQUEST_SERVICE.get(GET_COMPANY_ADJ).then((response) => {
          UTIL_SERVICE.console("RESULT GET_COMPANY_ADJ:", response.data);

          this.listAdj = [];
          this.listAdjAbono = [];
          response.data.map(v => {
            if (v.type === 0) {
              this.listAdj.push(v);
            } else {
              this.listAdjAbono.push(v);
            }
          });
          this.listAdj.unshift({id: '', name: 'Selecione'});
          this.listAdjAbono.unshift({id: '', name: 'Selecione'});

        }).catch(reason => {
          try {
            UTIL_SERVICE.historyLog(false, window.location.pathname, 'getListAdjustment', {}, true, reason.response.data);
          } catch (e) {}

          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
      },
      getListException() {
        REQUEST_SERVICE.get(GET_EXCEPTION).then((response) => {
          UTIL_SERVICE.console("RESULT GET_EXCEPTION:", response.data);

          this.listException = response.data;

        });
      },
    },
    watch: {
      loadData: function (value) {
        if (value) {
          this.makeSolicitation();
        }
      },
      typeSelected: function () {
        if (this.typeSelected === 3) {
          this.motiveAllowance.name = 'Outro';
        }
      }
    },
    beforeMount() {
      let dataUserInfo = UTIL_SERVICE.getStorage('userInfo');
      let permissionDsr = UTIL_SERVICE.getStorage('permissionDsr');
      if (permissionDsr) this.enableDsr = permissionDsr;
      try {
        if(dataUserInfo.company.sporadic) {
          this.needException = dataUserInfo.company.sporadic
        }
      } catch (e) {}
      moment.locale('pt-br');
      this.getListAdjustment();
      this.getListException();
    },
    mounted() {
      document.addEventListener('dragstart', (e) => {
        e.target.classList.add('dragging');
      });

      document.addEventListener('dragend', (e) => {
        e.target.classList.remove('dragging');
      });
    },
    validations: {
      motiveAdjustment: {required},
      motiveAllowance: {required},
      dataSend: {},
      listHours: {
        required,
        minLength: minLength(2),
        $each: {
          entry: {
            required
          },
          hourEntry: {
            required
          },
          exit: {
            required
          },
          hourExit: {
            required
          }
        }
      },
      listHoursAbonoHalfDay: {
        required,
        minLength: minLength(1),
        $each: {
          entry: {
            required
          },
          hourEntry: {
            required
          },
          exit: {
            required
          },
          hourExit: {
            required
          }
        }
      }
    }
  }
</script>

<style lang="scss">
.modal-content {
  width: 458px;
  padding: 24px;
  border-radius: 20px;
  background: var(--leftMenuColor);
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.07);

  .modal-header {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0;

    svg {
      width: 18px;
      height: 18px;
    }

    svg * path {
      fill: var(--titleSide);
    }

    h2 {
      color: var(--titleBox);
      font-size: 18px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      margin: 0;
    }

    ion-icon {
      position: absolute;
      right: 0;
      font-size: 23px;
      color: var(--titleSide);
      cursor: pointer;
      transition: all .3s;

      &:hover {
        transform: scale(1.2);
      }
    }

    &::before {
      display: none;
    }

    &::after {
      content: '';
      position: absolute;
      display: block;
      bottom: -16px;
      width: 100%;
      height: 1px;
      background: #E6E6E6;
    }
  }

  .first-section {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 16px;

    h3 {
      color: var(--titleBox);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      span {
        font-weight: 500;
        color: var(--titleBox);
      }
    }

    .box-buttons {
      display: flex;
      place-content: center;
      gap: 8px;

      button {
        padding: 6px 16px;
        border: 1px solid #7F8897;
        border-radius: 20px;
        background: none;

        color: var(--titleSide);
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      .btnDrs,
      .btnAdjustment,
      .btnAllowance {
        color: #fff;
        background: #1B59F8;
      }
    }

    &::after {
      content: '';
      position: absolute;
      display: block;
      bottom: -16px;
      width: 100%;
      height: 1px;
      background: #E6E6E6;
    }
  }

  .second-section {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 10px;
    padding: 32px 42px 0 42px;
    margin-bottom: 32px;

    &:after {
      content: '';
      position: absolute;
      display: block;
      left: 0;
      bottom: -16px;
      width: 100%;
      height: 1px;
      background: #E6E6E6;
    }

    label {
      position: relative;
      display: flex;
      align-items: center;
      gap: 8px;

      input {
        width: 18px;
        height: 18px;
        margin: 0;
        opacity: 0.6;
        cursor: pointer;
      }

      span {
        color: var(--activeHoverSidebar);
        font-size: 12px;
        font-weight: 400;
      }

      svg {
        position: relative;
        cursor: pointer;

        &:hover + p {
          display: block;
        }
      }

      p {
        position: absolute;
        top: -60px;
        right: 30px;
        max-width: 36ch;
        text-align: justify;
        padding: 8px 12px;
        color: #fff;
        background: #020202;
        border-radius: 10px;
        font-size: 10px;
        display: none;
      }
    }
  }

  .third-section {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 28px;

    img {
      margin-left: -20px;
    }

    p {
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      color: var(--text);
      max-width: 20ch;
      opacity: 0.75;
    }
  }

  .drag-content {
    margin-top: -12px;

    .draggable-box {
      .draggable-list {
        position: relative;
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 24px 32px 64px 32px;

        .item {
          position: relative;
          width: 304px;
          display: flex;
          flex-direction: column;
          padding: 12px 9px;
          border-radius: 24px;
          border: 1px solid #DFDEDE;
          background: color(--leftMenuColor);
          box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);
          margin-left: -4px;

          .delete {
            position: absolute;
            top: -20px;
            right: 72px;

            ion-icon {
              font-size: 20px;
              cursor: pointer;
              color: #FF445D;
            }
          }

          p {
            color: var(--text);
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            margin-left: 10px;

            span {
              font-weight: 700;
              opacity: 0.75;
              color: #2ACC6B;
            }
          }

          .box-inputs {
            position: relative;
            display: flex;
            gap: 13px;

            .input-date {
              display: flex;
              align-items: center;
              width: 146px;
              height: 35px;
              padding: 0 0 0 12px;
              border-radius: 16px;
              border: 1px solid #DFDEDE;
              color: var(--titleSide);
              font-size: 15px;
              font-style: normal;
              font-weight: 400;

              input {
                width: 100%;
                height: 100%;
                background: none !important;
                border-radius: 16px !important;
                border: none !important;
                padding: 8px 4px;
                font-weight: 600;
                color: var(--titleSide) !important;
                opacity: 0.75;
              }
            }

            .input-text {
              display: flex;
              align-items: center;
              width: 136px;
              height: 35px;
              padding: 0 12px;
              border-radius: 16px;
              border: 1px solid #DFDEDE;
              background: none !important;
              color: var(--titleSide);
              font-size: 15px;
              font-style: normal;
              font-weight: 400;

              input {
                width: 100%;
                height: 100%;
                background: none !important;
                font-weight: 600 !important;
                opacity: 0.75;
                border: none !important;
                color: var(--titleSide) !important;
              }
            }
          }

          ion-icon {
            position: absolute;
            font-size: 40px;
            top: 29px;
            right: -54px;
            color: #AEAEAE;
            cursor: pointer;
          }
        }

        .item.dragging :where(p, .box-inputs, ion-icon) {
          opacity: 0.4;
        }

        .error-value {
          text-align: center;
          color: #d9534f;
        }

        .create {
          position: absolute;
          bottom: 16px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          gap: 8px;
          width: max-content;
          background: none;
          border: none;

          color: var(--darkBlue);
          font-size: 14px;
          font-style: normal;
          font-weight: 500;

          ion-icon {
            font-size: 20px;
            vertical-align: middle;
            color: var(--darkBlue);
          }
        }
      }
    }
  }

  .content-motive {
    display: flex;
    flex-direction: column;
    gap: 16px;

    label {
      position: relative;
      width: 100%;
      height: 36px;
      border-radius: 10px;
      border: 1px solid #7F8897;

      span {
        position: absolute;
        top: -12px;
        left: 12px;
        padding: 0 6px;
        background: var(--bodyContrast);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        color: var(--defaultText);
      }

      input, select {
        background: none !important;
        padding: 6px 12px;

        font-size: 16px;
        font-style: normal;
        font-weight: 400;
      }

      select {
        cursor: pointer;

        &:focus + ion-icon {
          transform: rotate(180deg);
        }
      }

      ion-icon {
        position: absolute;
        right: 12px;
        top: 8px;
        font-size: 20px;
        color: #7F8897;
        transition: all .3s;
      }
    }

    .required-field {
      margin-top: -16px;
    }
  }

  .input-upload {
    .name-file {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      color: var(--titleBox);
    }

    button {
      display: block;
      margin: 16px auto;
      background: none;
      border: none;

      font-size: 12px;
      font-weight: 500;
      color: var(--darkBlue);

      ion-icon {
        vertical-align: middle;
        margin-right: 8px;
        font-size: 20px;
        color: var(--darkBlue);
      }

      .animation {
        display: inline;
        ion-icon {
          animation: loadAnimation 1s linear infinite;
        }
      }
    }
  }

  .btn-request {
    display: block;
    padding: 6px 16px;
    border: none;
    border-radius: 20px;
    background: #1B59F8;
    margin: 0 auto;
    min-width: 200px;

    span {
      color: #fff;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }

  @keyframes loadAnimation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/views/modals/modalSolicitation.vue